import _map from 'lodash/map';
import APPCONFIG from '../../constants/Config';
import { WS_TOPIC_PLANNINGS } from '../../constants/App';
import * as wsEvents from '../../constants/WsEvents';
import {
  REINIT_STATE,
  WS_RECEIVED_OPERATION,
  GET_INSTALLATION_PLANNINGS,
  GET_INSTALLATION_PLANNINGS_SUCCESS,
  GET_INSTALLATION_PLANNINGS_ERROR,
  GET_INSTALLATION_PLANNING,
  GET_INSTALLATION_PLANNING_SUCCESS,
  GET_INSTALLATION_PLANNING_ERROR,
  ADD_INSTALLATION_PLANNING,
  ADD_INSTALLATION_PLANNING_SUCCESS,
  ADD_INSTALLATION_PLANNING_ERROR,
  UPDATE_INSTALLATION_PLANNING,
  UPDATE_INSTALLATION_PLANNING_SUCCESS,
  UPDATE_INSTALLATION_PLANNING_ERROR,
  DELETE_INSTALLATION_PLANNING,
  DELETE_INSTALLATION_PLANNING_SUCCESS,
  DELETE_INSTALLATION_PLANNING_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/planning';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.installationPlanning;
const installationPlanning = (state = initialSettings, action) => {
  let key;
  let wsPayload;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullInstallation' || action.target === 'currentInstallation') {
        return {
          ...state,
          list: { ...initialSettings.list },
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'addInstallationPlanning':
          key = 'add';
          break;
        case 'updateInstallationPlanning':
          key = 'update';
          break;
        case 'deleteInstallationPlanning':
          key = 'delete';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // WEB SOCKET
    case WS_RECEIVED_OPERATION:
      if (action.topic && action.topic === WS_TOPIC_PLANNINGS) {
        switch (action.operation) {
          case wsEvents.EVENT_CREATE:
          case wsEvents.EVENT_UPDATE:
          case wsEvents.EVENT_DELETE:
            return {
              ...state,
              list: {
                ...state.list,
                desynchronized: true,
              },
            };
          case wsEvents.EVENT_HEAD:
            wsPayload = action.payload;
            if (wsPayload) {
              // Update the list of plannings by updating sync status of the concerned planning
              return {
                ...state,
                list: {
                  ...state.list,
                  elements: _map(state.list.elements, (planning) => (planning.id === wsPayload.id
                    ? {
                      ...planning,
                      sync_status: wsPayload.sync_status,
                    } : planning
                  )),
                },
              };
            }
            return state;
          default:
            return state;
        }
      }
      return state;
    // LIST
    case GET_INSTALLATION_PLANNINGS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: null,
          error: null,
          loading: true,
          desynchronized: false,
        },
      };
    case GET_INSTALLATION_PLANNINGS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
          desynchronized: false,
        },
      };
    case GET_INSTALLATION_PLANNINGS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserialize(action.data.data),
          loading: false,
          desynchronized: false,
        },
      };
    // GET
    case GET_INSTALLATION_PLANNING:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_INSTALLATION_PLANNING_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_PLANNING_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // ADD
    case ADD_INSTALLATION_PLANNING:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case ADD_INSTALLATION_PLANNING_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_INSTALLATION_PLANNING_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          asyncOperation: action.data.data,
        },
      };
    // UPDATE
    case UPDATE_INSTALLATION_PLANNING:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          idPlanning: action.idPlanning,
          error: null,
        },
      };
    case UPDATE_INSTALLATION_PLANNING_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_INSTALLATION_PLANNING_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          asyncOperation: action.data.data,
        },
      };
    // DELETE
    case DELETE_INSTALLATION_PLANNING:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          idPlanning: action.idPlanning,
          error: null,
        },
      };
    case DELETE_INSTALLATION_PLANNING_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_INSTALLATION_PLANNING_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    default:
      return state;
  }
};

export default installationPlanning;



// WEBPACK FOOTER //
// ./reducers/installation/installationPlanning.js